// Experiment lifecycle:
//   1. Add experiment here and deploy:
//        my_experiment: ['variant_a', 'variant_b']
//      The first variant is the default for users without a cookie (e.g. cookies disabled).
//   2. Set exp_active:my_experiment to "true" in the Cloudflare KV experiments namespace to start assigning users.
//   3. To end the experiment: set exp_active:my_experiment to "false" in the Cloudflare KV experiments namespace, or delete the key entirely.
//      No new users will be assigned. Existing cookie holders keep their variant — use a date range in your analytics
//      tool to filter data up to the end date.
//   4. Once a winner is picked: hardcode the winning variant's behaviour, remove the experiment
//      from EXPERIMENTS, and deploy. Existing cookie entries for that experiment are ignored.
//
// Running several experiments at once:
//   Experiments are assigned independently and stored together in one `experiments` cookie,
//   so a user can be enrolled in all of them at the same time. Each experiment still sees your
//   full traffic — running two does not halve either one's sample size. Variant counts are
//   tracked per experiment, and any number of variants per experiment is supported.
//
//   Keep concurrent experiments on clearly separate surfaces. Two experiments changing the same
//   area can collide visually and make an effect impossible to attribute; separating their main
//   effects would need far more traffic than measuring either one alone.
//
//   Adding an experiment mid-flight is safe. On a user's next full page load the middleware adds
//   the new assignment and preserves existing ones — it never re-randomises an experiment a user
//   is already enrolled in. Note this happens on document requests only, so a long-open tab picks
//   up the new experiment on its next reload, not immediately.
//
// Re-running an experiment from scratch:
//   Do not try to clear users' cookies — that would also wipe assignments for every other running
//   experiment and re-randomise users mid-test. Give the new run a new name (`search_bar_v2`)
//   instead. Nobody holds an assignment under that name, so everyone is freshly assigned, and the
//   old name is ignored once removed from EXPERIMENTS.
export const EXPERIMENTS = {
    search_bar: ['variant_a', 'variant_b']
};
//# sourceMappingURL=experiment.js.map